import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { authAdditionalSignerEmail } from "../../connectors/connectors";
import { useAppDispatch } from "../../app/hooks";
import {
  onUpdateDraftUUID,
  onUpdateFormData,
} from "../../reducers/onboardingDataReducer";
import {
  updateDraftBase,
  updateSignatureRequestId,
} from "../../reducers/authReducer";
import { LoadingCircle } from "@allaria-tech/matter/LoadingCircle";

import styles from "./PreloadTemplateLanding.module.scss";
import { goToStep } from "../../app/utils";
import { getCompanyData } from "../../utils/companies";

const PreloadTemplateLanding = () => {
  const dispatch = useAppDispatch();

  const [searchParams] = useSearchParams();
  const externalCode = searchParams.get("externalCode");
  const email = searchParams.get("email");

  // Replace spaces with '+' if the email requires it
  const decodedEmail = email ? email.replace(/ /g, "+") : null;

  const handleSendRequest = async () => {
    try {
      if (!externalCode && !decodedEmail) return;

      const resp = await authAdditionalSignerEmail({
        email: decodedEmail || "",
        es: true,
        companyType: getCompanyData().companyName,
        oldAuth: true,
      });

      dispatch(updateSignatureRequestId(resp.data.signatureRequestId));
      dispatch(updateDraftBase(null));
      goToStep({ dispatch, step: 2 });
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    if (externalCode && decodedEmail) {
      dispatch(onUpdateDraftUUID(externalCode || ""));
      dispatch(onUpdateFormData({ email: decodedEmail }));
      handleSendRequest();
    }
  }, [externalCode, decodedEmail]);

  return (
    <div className={styles.container}>
      <LoadingCircle />
    </div>
  );
};

export default PreloadTemplateLanding;
